import IBaseComponent from '@components/FormFlow/Interfaces/Base/IBaseComponent';
import IScoreComponent, { Result } from '@components/FormFlow/Interfaces/FormflowComponents/IScoreComponent';
import FormflowContext from '@components/FormFlow/Util/FormflowContext';
import { ComponentType } from '@interfaces/component-type';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Button, Icon, Row } from 'antd';
import React from 'react';

import { InstructionTaskComponent } from '../TextInstructionComponent';
import { ScoreComponetValidated } from './Score/ScoreTask';

interface IScoreTaskComponentStateType {
  instructionTitle: string;
  description?: string;
  results: Result[];
};

export class ScoreComponent implements IScoreComponent {
  id: string;
  type: ComponentType;
  title: string;
  description?: string;
  results: Result[];


  constructor(id: string = '') {
    this.id = id;
    this.type = ComponentType.SCORE;
    this.title = '';
    this.results = [{
      label: '',
      min: undefined,
      max: undefined
    }]
    return this;
  }
}

export default class ScoreTaskComponent extends React.Component<IScoreComponent, IScoreTaskComponentStateType> {

  constructor(props: IScoreComponent) {
    super(props);
    this.state = {
      instructionTitle: this.props.title || '',
      description: this.props.description || undefined,
      results: this.props.results
    };
  }

  componentDidMount() {
    const newResults = Object.assign({}, this.state.results);

    for (const [index, resulItems] of this.state.results.entries()) {
      if (resulItems.min === resulItems.max) {
        newResults[index].operator = 'equals'
      }
      else if (resulItems.min === undefined || resulItems.min === null) {
        newResults[index].operator = 'less'
      }
      else if (resulItems.max === undefined || resulItems.max === null) {
        newResults[index].operator = 'great'
      }
    }

    this.setState({ results: this.state.results })
  }

  //#region HANDLERS
  handleIntructionTitleChange = async (evt: any) => {
    this.setState({ instructionTitle: evt.target.value });
  }

  handleDescriptionChange = async (evt: any) => {
    this.setState({ description: evt.target.value });
  }
  handleAddNewScore = async () => {
    this.setState({
      results: this.state.results.concat([{ operator: '', label: '', min: undefined, max: undefined }]),
    });
  }
  handleInputScoreChange = (idx: any) => async (evt: any) => {
    const newScore = this.state.results.map((score, sidx) => {
      if (idx !== sidx) return score;
      if (score.operator === 'equals') {
        return { ...score, min: evt, max: evt };
      }
      else if (score.operator === 'great') {
        return { ...score, min: evt, max: undefined };
      }
      else if (score.operator === 'less') {
        return { ...score, min: undefined, max: evt };
      }
      return score;
    });
    this.setState({ results: newScore });
  }
  handleInputLabelChange = (idx: any) => async (evt: any) => {
    const newScore = this.state.results.map((score, sidx) => {
      if (idx !== sidx) return score;
      return { ...score, label: evt.target.value };
    });
    this.setState({ results: newScore });
  }
  handleInputSelectChange = (idx: any) => async (evt: any) => {
    const newScore = this.state.results.map((score, sidx) => {
      if (idx !== sidx) return score;
      return { ...score, operator: evt };
    });
    this.setState({ results: newScore });
  }
  handleRemoveScore = (index: number) => async () => {
    this.setState({
      results: this.state.results.filter((section: any, sindex: number) => index !== sindex),
    });
  }

  //#endregion

  onSubmitScoreComponent(updateFormflowWithComponent: (component: IBaseComponent) => void) {
    const newScoreComponent: IScoreComponent = {
      id: this.props.id,
      type: ComponentType.SCORE,
      title: this.state.instructionTitle,
      description: this.state.description,
      results: this.state.results
    }

    console.log('valor do create', newScoreComponent)
    updateFormflowWithComponent(newScoreComponent);
  }

  render() {
    const {
      instructionTitle,
    } = this.state

    return (
      <div>
        <InstructionTaskComponent
          conditionsTaskComponents={false}
          inputDescriptionValue={this.props.description != undefined ? this.props.description : ''}
          visibleDescription={true}
          inputTitleValue={instructionTitle}
          onInputInstructionChange={() => this.handleIntructionTitleChange}
          onChangeDescription={() => this.handleDescriptionChange}
          titleComponent={I18n.l("formflow.components.score.titleScoreComponent")}
          descriptionComponent={I18n.l("formflow.components.score.descriptionScoreComponent")}
          exampleDescriptionComponent={I18n.l("formflow.components.score.exampleDescriptionScoreComponent")}
          checkboxtTaskPerform={true}
        />
        {this.state.results.map((resultItems, idx: number) => (
          <ScoreComponetValidated
            key={idx}
            onChangeSelect={this.handleInputSelectChange(idx)}
            onChangeScore={this.handleInputScoreChange(idx)}
            onChangeLabel={this.handleInputLabelChange(idx)}
            valueSelect={resultItems.operator ? resultItems.operator : ''}
            valueScore={resultItems.operator === 'great' ? resultItems.min :
              resultItems.operator === 'less' ? resultItems.max :
                resultItems.operator === 'equals' ? resultItems.min : undefined}
            valueLabel={resultItems.label}
            handleRemoveScore={this.handleRemoveScore(idx)}
          />
        ))}
        <Button style={{ marginTop: '10px', marginLeft: '3rem' }} size="large" className="goepik-btn-border-main" onClick={this.handleAddNewScore}>
          <Icon type="plus" /> {I18n.l('users.addfield').toUpperCase()}
        </Button>
        <FormflowContext.Consumer>
          {({ destroyComponentModalWindow, updateFormflowWithComponent }) => (
            <div>
              <ButtonStyle>
                <Row type="flex" justify="end">
                  <Button className="button-cancel" type="primary" onClick={destroyComponentModalWindow} ghost>{I18n.l('common.cancel')}</Button>
                  <Button className="button-save" type="primary" disabled={
                    instructionTitle.length === 0 ||
                      instructionTitle.length < 3
                      ? true : false}
                    onClick={() => { this.onSubmitScoreComponent(updateFormflowWithComponent) }}
                  >
                    {I18n.l('common.save')}</Button>
                </Row>
              </ButtonStyle>
            </div>
          )}
        </FormflowContext.Consumer>
      </div>
    );
  }
}

//#region CSS
const ButtonStyle = styled.div`
    float:right;
    margin-top: 15vh;
    margin-right: 50px;
    
    .button-save{
        bottom: 5%;
        width: 6rem;
    }
    .button-cancel{
        bottom: 5%;
        width: 6rem;
        margin-left: -6.5rem;
    }
`;
//#endregion
